var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15957 10.8704C9.05957 10.8604 8.93957 10.8604 8.82957 10.8704C6.44957 10.7904 4.55957 8.84037 4.55957 6.44037C4.55957 3.99037 6.53957 2.00037 8.99957 2.00037C11.4496 2.00037 13.4396 3.99037 13.4396 6.44037C13.4296 8.84037 11.5396 10.7904 9.15957 10.8704Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4103 3.99963C18.3503 3.99963 19.9103 5.56963 19.9103 7.49963C19.9103 9.38963 18.4103 10.9296 16.5403 10.9996C16.4603 10.9896 16.3703 10.9896 16.2803 10.9996",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15973 14.5596C1.73973 16.1796 1.73973 18.8196 4.15973 20.4296C6.90973 22.2696 11.4197 22.2696 14.1697 20.4296C16.5897 18.8096 16.5897 16.1696 14.1697 14.5596C11.4297 12.7296 6.91973 12.7296 4.15973 14.5596Z",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3398 20.0004C19.0598 19.8504 19.7398 19.5604 20.2998 19.1304C21.8598 17.9604 21.8598 16.0304 20.2998 14.8604C19.7498 14.4404 19.0798 14.1604 18.3698 14.0004",
    stroke: "#313131",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.1b1bd09823611702269d840e98cd0427.svg";
export { ForwardRef as ReactComponent };